module.exports = __webpack_public_path__ + "img/IT0000835701279.837d5f0a.svg";